var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
import Overlay from '../overlay/overlay';
var Feedback = (function (_super) {
    __extends(Feedback, _super);
    function Feedback() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.saveRef = function (name) { return function (node) {
            name === 'sentinel' ? (_this.sentinel = node) : (_this.wrap = node);
        }; };
        _this.onKeyDown = function (e) {
            if (e.keyCode === 27) {
                _this.props.onClose();
            }
            if (e.keyCode === 9) {
                var activeElement = document.activeElement;
                var modalRoot = _this.wrap;
                if (e.shiftKey) {
                    if (activeElement === modalRoot && _this.sentinel) {
                        _this.sentinel.focus();
                    }
                }
                else if (activeElement === _this.sentinel && modalRoot) {
                    modalRoot.focus();
                }
            }
        };
        return _this;
    }
    Feedback.prototype.componentDidMount = function () {
        var _this = this;
        setTimeout(function () { return _this.wrap && _this.wrap.focus(); }, 0);
    };
    Feedback.prototype.render = function () {
        var overlay = this.props.overlay;
        var CustomOverlay = overlay;
        return (React.createElement(Wrapper, { onKeyDown: this.onKeyDown },
            React.createElement("div", { tabIndex: -1, ref: this.saveRef('wrap') }, CustomOverlay ? (React.createElement(CustomOverlay, { onClick: this.props.onClose })) : (React.createElement(Overlay, { onClick: this.props.onClose }))),
            this.props.children,
            React.createElement("div", { tabIndex: 0, ref: this.saveRef('sentinel'), style: { width: 0, height: 0, overflow: 'hidden' } })));
    };
    Feedback.defaultProps = {
        onClose: function () { },
    };
    return Feedback;
}(React.Component));
export default Feedback;
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  bottom: 0;\n  display: flex;\n  flex: 1;\n  justify-content: center;\n  left: 0;\n  min-height: 200px;\n  position: fixed;\n  right: 0;\n  top: 0;\n"], ["\n  align-items: center;\n  bottom: 0;\n  display: flex;\n  flex: 1;\n  justify-content: center;\n  left: 0;\n  min-height: 200px;\n  position: fixed;\n  right: 0;\n  top: 0;\n"])));
var templateObject_1;
//# sourceMappingURL=feedback.js.map